import { cataloguePackQuantity, type GuideCatalogueProduct } from "./guide";

export const shopOrigins = ["https://spoolimports.com", "https://www.spoolimports.com"];

const escape = (value: string): string => value.replace(/[&<>"']/g, (char) =>
  ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char]!);

function shopUrl(value: string | null): string | null {
  try {
    const url = new URL(value ?? "");
    return shopOrigins.includes(url.origin) && !url.username && !url.password ? url.href : null;
  } catch { return null; }
}

/** Catalogue enrichment is optional; a missing listing must still offer a useful next step. */
export function renderGuideProduct(sku: string, products: GuideCatalogueProduct[], compact = false): string {
  const title = products.find((product) => product.title)?.title ?? "Contact us for product details and availability";
  const body = `<strong>${escape(sku)}</strong><span>${escape(title)}</span>`;
  const className = `guide-product ${compact ? "compact" : ""}`;
  const search = `https://spoolimports.com/catalogsearch/result/?q=${encodeURIComponent(sku)}`;
  if (products.length === 1 && products[0]?.sku.toUpperCase() === sku.toUpperCase()) {
    const url = shopUrl(products[0].url);
    return `<a class="${className}" href="${escape(url ?? search)}" target="_top">${body}<small>${url ? "View product" : "Find in store"}</small></a>`;
  }
  if (!products.length) return `<a class="${className}" href="${escape(search)}" target="_top">${body}<small>Find in store</small></a>`;
  const listings = products.map((product) => {
    const quantity = cataloguePackQuantity(sku, product.sku);
    const label = `${escape(product.sku)}${quantity && quantity > 0 ? ` · pack of ${quantity}` : ""}`;
    const url = shopUrl(product.url) ?? `https://spoolimports.com/catalogsearch/result/?q=${encodeURIComponent(product.sku)}`;
    return `<a href="${escape(url)}" target="_top">${label}</a>`;
  }).join("");
  return `<div class="${className} has-listings">${body}<div class="guide-product-listings"><small>Available product options</small>${listings}</div></div>`;
}
